import React, { useState, useEffect } from "react";
import { Form } from "antd";
import svg168 from "../../../../assets/svg/svg168.svg";

function PurchaseType({ form }) {
  const [activeTab, setActiveTab] = useState("Airtime Top-Up");

  useEffect(() => {
    // Set initial value in form
    form.setFieldsValue({ purchaseType: "Airtime Top-Up" });
  }, [form]);

  const handleTabChange = (tab, displayName) => {
    setActiveTab(displayName);
    form.setFieldsValue({ purchaseType: displayName });
  };

  return (
    <div className="rounded-[0.75rem] bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.05)] p-[0.75rem] ">
      <div className="flex items-center gap-[0.5rem]">
        <div className="w-[1.5rem] h-[1.5rem] rounded-[0.375rem] bg-[#EDEDF1] flex items-center justify-center">
          <img src={svg168} alt="svg168" />
        </div>
        <span className="text-[#0F172A] font-[500] font-lexendS text-[0.875rem] leading-[1.5rem]">
          Choose Purchase Type
        </span>
      </div>

      <Form.Item name="purchaseType" hidden initialValue="Airtime Top-Up">
        <input type="hidden" />
      </Form.Item>

      <div className="mt-[.75rem]">
        <div className="inline-flex rounded-[0.5rem] border border-[#DCDAE2] bg-[#F6F6F8] p-[0.25rem]">
          <button
            type="button"
            onClick={() => handleTabChange("airtime", "Airtime Top-Up")}
            className={`flex flex-col justify-center items-center px-[0.75rem] py-[0.375rem] text-[0.875rem] font-lexend rounded-[0.375rem] leading-[1.25rem] transition-all ${
              activeTab === "Airtime Top-Up"
                ? "bg-white text-[#000] font-[500] shadow-[0_0_0_1px_rgba(0,0,0,0.05),0_1px_2px_0_rgba(0,0,0,0.05)]"
                : "bg-transparent text-[#7A7493] font-[400]"
            }`}
          >
            Airtime Top-Up
          </button>
          <button
            type="button"
            onClick={() => handleTabChange("data", "Data Bundles")}
            className={`flex flex-col justify-center items-center px-[0.75rem] py-[0.375rem] text-[0.875rem] font-lexend rounded-[0.375rem] leading-[1.25rem] transition-all ${
              activeTab === "Data Bundles"
                ? "bg-white text-[#000] font-[500] shadow-[0_0_0_1px_rgba(0,0,0,0.05),0_1px_2px_0_rgba(0,0,0,0.05)]"
                : "bg-transparent text-[#7A7493] font-[400]"
            }`}
          >
            Data Bundles
          </button>
        </div>
      </div>
    </div>
  );
}

export default PurchaseType;
